import { getRandomNumber } from '@jfs/utils'
import { AddressType, AddressV2 } from '../../data/models/Address'
import { Limit, Limits } from '../../data/models/Limits'
import { PaymentAcceptanceParser } from './paymentAcceptance'

const profileFromJSON = (data: any, mid: string): any => {
  const { profile } = data
  const { financialProfile } = data
  const { contact } = data
  const { address } = data
  const { terminals } = data

  const parsedAddresses: AddressV2[] = []
  address.map((item: any) => {
    const addressItem: any = {
      id: getRandomNumber(600, address?.length) ?? '',
      type: item?.addressType === 'Residential' ? AddressType.Residential : AddressType.Business, //Check
      line1: `${item?.flatNumber ?? ''} ${item?.buildingName ?? ''} ${item?.street ?? ''}`,
      line2: `${item?.areaLocality ?? ''} ${item?.subLocality ?? ''} ${item?.landMark ?? ''}`,
      pincode: item?.pinCode ?? '',
      city: item?.district ?? '',
      state: item?.state ?? '',
      country: item?.countryCode === 356 ? 'India' : '' ?? '',
    }
    parsedAddresses.push(addressItem)
    return addressItem
  })

  const parsedContacts: any[] = []
  contact.map((item: any) => {
    const contactV2: any = {
      email: item?.emailID ?? 'NA',
      mobile: item?.mobileNumber ?? 'NA',
      website: item?.websiteURL ?? 'NA',
      addresses: parsedAddresses,
    }
    parsedContacts.push(contactV2)
    return contactV2
  })

  const parsedBankAccount: any = {
    number: financialProfile?.settlementAccountBankAccountNumber ?? '',
    type: '',
    holderName: '',
    bank: {
      id: getRandomNumber(700, 1000) ?? '',
      ifsc: financialProfile?.settlementAccountBankIFSCCode ?? '',
      branch: '',
      name: financialProfile?.settlementAccountBankName ?? '',
      address: {
        id: getRandomNumber(1000, 5000),
        type: AddressType.Business,
        line1: financialProfile?.settlementAccountBankAccountAddress ?? '',
        line2: '',
        pincode: '',
        city: '',
        state: '',
        country: '',
      },
    },
  }

  const limitsData = Limits.create({
    type: Limit.JM,
    maxLimit: '0',
  })

  const limitsData1 = Limits.create({
    type: Limit.CCDC,
    maxLimit: '0',
  })

  const merchantItem: any = {
    mid: terminals[0]?.mid ?? mid,
    tId: terminals[0]?.terminalID ?? '',
    name: profile?.brandName ?? '',
    businessName: profile?.brandName ?? '',
    vpa: financialProfile?.businessVpa ?? 'NA',
    bankAccount: parsedBankAccount,
    acceptedPayments: [],
    limits: [limitsData, limitsData1],
    status: profile?.merchantStatus ?? '',
    type: profile?.merchantType ?? '',
    age: profile?.yearsOfBusiness ?? '',
    authorisedSignatory: profile?.authSigName ?? '',
    contact: parsedContacts[0],
    dailyTransactionVolume: financialProfile?.dailyTransactionVolume ?? '',
  }
  return merchantItem
}

const limitsData = Limits.create({
  type: Limit.JM,
  maxLimit: '0',
})

const limitsData1 = Limits.create({
  type: Limit.CCDC,
  maxLimit: '0',
})

const defaultAddress = {
  address: 'Reliance Corporate Park, Thane–Belapur Road, Ghansoli',
  state: 'Maharashtra',
  city: 'Navi Mumbai',
  country: 'India',
  pincode: '400701',
  latitude: '19.1242',
  longitude: '73.0032',
}

export const profileFromEntityJSON = (data: any, mid: string) => {
  let merchantData = {}
  if (data) {
    const {
      contactDetails,
      addressDetails,
      businessName,
      settlementDetails,
      status,
      type,
      businessProfile,
      authorisedSignatoryDetails,
      terminalDetails,
      legalOwnerName,
      entityConfigs,
    }: any = data

    const parsedBankAccount: any = {
      number: settlementDetails?.accountNumber ?? '',
      type: settlementDetails?.acctType ?? '',
      holderName: settlementDetails?.beneficiaryName ?? '',
      bank: {
        id: getRandomNumber(700, 1000) ?? '',
        ifsc: settlementDetails?.ifsCode ?? '',
        branch: '',
        name: settlementDetails?.beneficiaryName ?? '',
        address: {
          id: getRandomNumber(1000, 5000),
          type: AddressType.Business,
          line1: settlementDetails?.addressLine1 ?? '',
          line2: '',
          pincode: '',
          city: '',
          state: '',
          country: settlementDetails?.countryCode === 356 ? 'India' : '' ?? '',
        },
      },
    }
    let authorisedSignatory: any = authorisedSignatoryDetails?.authSigFirstname ?? ''
    authorisedSignatory = authorisedSignatoryDetails?.authSigLastname
      ? `${authorisedSignatory} ${authorisedSignatoryDetails?.authSigLastname}`
      : authorisedSignatory

    const addressObj = getLocRole(addressDetails, true) ?? {}
    const { addressLine1, addressLine2, addressLine3 } = addressObj
    let registeredAddress: any = addressLine1 ? `${addressLine1}` : ''
    registeredAddress = addressLine2 ? registeredAddress + ', ' + addressLine2 : registeredAddress
    registeredAddress = addressLine3 ? registeredAddress + ', ' + addressLine3 : registeredAddress

    const contactObj: any = getLocRole(contactDetails, false) ?? {}
    const { firstName = '', lastName = '', emailId = '', mobileNumber = '', websiteUrl = 'NA' } = contactObj

    const address = {
      id: getRandomNumber(600, contactDetails?.length) ?? '',
      type: contactObj?.type?.toLowerCase() === 'residential' ? AddressType.Residential : AddressType.Business, //Check
      line1: `${addressObj?.addressLine1 ?? ''}`,
      line2: `${addressObj?.addressLine2 ?? ''}`,
      pincode: addressObj?.pincode ?? defaultAddress.pincode,
      city: addressObj?.city ?? defaultAddress.city,
      state: addressObj?.state ?? defaultAddress.state,
      country: addressObj?.countryCode === 356 ? 'India' : defaultAddress.country,
    }

    const contact = {
      email: emailId,
      mobile: mobileNumber,
      website: websiteUrl,
      addresses: [address],
      latitude: addressObj?.latitude ?? defaultAddress.latitude,
      longitude: addressObj?.longitude ?? defaultAddress.longitude,
      registeredAddress: registeredAddress ?? defaultAddress.address,
      registeredState: addressObj?.state ?? defaultAddress.state,
      registeredCity: addressObj?.city ?? defaultAddress.city,
      registeredCountry: addressObj?.countryCode === 356 ? 'India' : defaultAddress.country,
      registeredPinCode: addressObj?.pincode ?? defaultAddress.pincode,
    }

    const primaryAccount = terminalDetails?.find((merchant: any) => merchant.primary)
    const filteredAcceptedPayments = entityConfigs?.filter(
      (payment: any) => payment?.configType === 'PAYMENT_ACCEPTANCE',
    )
    const acceptedPayments = PaymentAcceptanceParser({ response: { configValues: filteredAcceptedPayments ?? [] } })

    // TODO: it will be list of mcc code has to be from backend
    const diableMccCodeList = ['7407']
    const mccInDisableList = diableMccCodeList.find((mccCode) => businessProfile?.mccCode === mccCode)
    merchantData = {
      mid: primaryAccount?.mid ?? mid,
      tId: primaryAccount?.terminalId ?? '',
      name: `${firstName} ${lastName}`,
      businessName: businessName ?? '',
      vpa: primaryAccount?.vpaLinkingDetails?.handle ?? '',
      bankAccount: parsedBankAccount,
      acceptedPayments: acceptedPayments,
      limits: [limitsData, limitsData1],
      status: status ?? '',
      type: type ?? 'Agent', //TODO: as per RBI guidlines type should be 'Grocery' from backend
      age: businessProfile?.yearsInBusiness ?? '',
      authorisedSignatory: legalOwnerName ?? '',
      contact: contact,
      dailyTransactionVolume: businessProfile?.dailyTransactionVolume ?? '',
      // TODO: this has to be come from backend
      disableBillPayment: !contactDetails?.length || mccInDisableList ? true : false,
    }
  }

  return merchantData
}

const getLocRole = (data: any, isAddress: boolean) => {
  const field = isAddress ? 'addressRole' : 'role'
  let item: any = data?.find((merchant: any) => merchant[field] === 'LOC')
  if (!item) {
    item = data?.[0]
  }
  return item
}

export { profileFromJSON }
